import { render, staticRenderFns } from "./TotalCard.vue?vue&type=template&id=c3a2f99c&"
import script from "./TotalCard.vue?vue&type=script&lang=js&"
export * from "./TotalCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib'
import { VCheckbox } from 'vuetify/lib'
import { VDataTable } from 'vuetify/lib'
installComponents(component, {
  VCard,
  VCheckbox,
  VDataTable,
})
